export default "__VITE_ASSET__CSdDWB9P__"